const gridLocaleText = {
  noRowsLabel: 'אין שורות להצגה',
  noResultsOverlayLabel: 'אין תוצאות',
  errorOverlayDefaultLabel: 'אירעה שגיאה',
  toolbarDensity: 'רזהון',
  toolbarDensityLabel: 'רזהון',
  toolbarDensityCompact: 'קטן',
  toolbarDensityStandard: 'רגיל',
  toolbarDensityComfortable: 'נוח',
  toolbarColumns: 'עמודות',
  toolbarColumnsLabel: 'הצג עמודות',
  toolbarFilters: 'סנן',
  toolbarFiltersLabel: 'הצג מסננים',
  toolbarFiltersTooltipHide: 'הסתר מסננים',
  toolbarFiltersTooltipShow: 'הצג מסננים',
  toolbarFiltersTooltipActive: (count) => `${count} מסננים פעילים`,
  toolbarExport: 'ייצוא',
  toolbarExportLabel: 'ייצוא',
  toolbarExportCSV: 'ייצוא ל-CSV',
  columnsPanelTextFieldLabel: 'חיפוש',
  columnsPanelTextFieldPlaceholder: 'שם העמודה',
  columnsPanelDragIconLabel: 'גרור לסידור',
  columnsPanelShowAllButton: 'הצג הכול',
  columnsPanelHideAllButton: 'הסתר הכול',
  filterPanelAddFilter: 'הוסף מסנן',
  filterPanelDeleteIconLabel: 'מחק מסנן',
  filterPanelOperators: 'פעולות',
  filterPanelOperatorAnd: 'וגם',
  filterPanelOperatorOr: 'או',
  filterPanelColumns: 'עמודות',
  filterPanelInputLabel: 'ערך',
  filterPanelInputPlaceholder: 'קלט',
  filterOperatorContains: 'מכיל',
  filterOperatorEquals: 'שווה',
  filterOperatorStartsWith: 'מתחיל ב',
  filterOperatorEndsWith: 'מסתיים ב',
  filterOperatorIs: 'הוא',
  filterOperatorNot: 'אינו',
  filterOperatorAfter: 'אחרי',
  filterOperatorOnOrAfter: 'בתאריך או אחרי',
  filterOperatorBefore: 'לפני',
  filterOperatorOnOrBefore: 'בתאריך או לפני',
  filterOperatorIsEmpty: 'ריק',
  filterOperatorIsNotEmpty: 'אינו ריק',
  filterValueAny: 'כל ערך',
  filterValueTrue: 'נכון',
  filterValueFalse: 'שקר',
  columnMenuLabel: 'תפריט',
  columnMenuShowColumns: 'הצג עמודות',
  columnMenuFilter: 'מסנן',
  columnMenuHideColumn: 'הסתר עמודה',
  columnMenuUnsort: 'בטל מיון',
  columnMenuSortAsc: 'מיון עולה',
  columnMenuSortDesc: 'מיון יורד',
  columnHeaderFiltersTooltipActive: (count) => `${count} מסננים פעילים`,
  columnHeaderFiltersLabel: 'הצג מסננים',
  columnHeaderSortIconLabel: 'מיין לפי',
  footerRowSelected: (count) => `${count} שורות נבחרו`,
  footerTotalRows: 'סך הכל שורות',
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount} מתוך ${totalCount} שורות`,
  checkboxSelectionHeaderName: 'בחירה',
  booleanCellTrueLabel: 'נכון',
  booleanCellFalseLabel: 'שקר'
  // MuiTablePagination: {
  //   labelRowsPerPage: 'שורות לעמוד:',
  //   labelDisplayedRows: '{from}-{to} מתוך {count}'
  // }
};

export default gridLocaleText;
